import { useRequest } from "../../../hooks/useRequest";
import { useCallback } from "react";
import { SolutionInvestment } from "../ProjectsInvestmentsCard";
import { dateRangeValidation } from "../../../shared/sharedFormSchema";
import routes from "../../../routes";

type Card =
  | "invested clients"
  | "units of sale"
  | "churn rate"
  | "invested projects";

type Metric =
  | Record<string, unknown>
  | Array<SolutionInvestment>
  | Record<string, number>
  | undefined;

const endpointMap: Record<Card, string> = {
  "invested clients": routes.api.reporting.investedClients.pattern,
  "invested projects": routes.api.reporting.investedProjects.pattern,
  "units of sale": routes.api.reporting.unitsOfSale.pattern,
  "churn rate": routes.api.reporting.churnRate.pattern,
};

function useFetchTotalClientsWithInvestments<T>(card: Card) {
  const { fetch, response, error, loading } = useRequest();
  const url = endpointMap[card];

  const fetchMetric = useCallback(
    ({ fromDate, toDate }: { fromDate: number; toDate: number }) => {
      const isValid = dateRangeValidation().isValidSync({
        fromDate,
        toDate,
      });

      if (isValid) {
        const params = new URLSearchParams({
          fromDate: fromDate ? fromDate.toString() : "",
          toDate: toDate ? toDate.toString() : "",
        });
        fetch("GET", `${url}?${params}`);
      }
    },
    [fetch, url],
  );

  const metric = response?.data as Metric;

  return {
    metric: metric as T,
    error,
    loading,
    fetchMetric,
  };
}

export default useFetchTotalClientsWithInvestments;
